export class GetCurrentSchoolYearUseCase {
  static execute() {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getUTCMonth();
    const august = 7;
    if (currentMonth >= august) {
      // August (month 7) onwards is the new school year
      return `${currentYear}/${currentYear + 1}`;
    }

    // January to July (months 0-7)
    return `${currentYear - 1}/${currentYear}`;
  }
}
